export default [
  {
    id: 1,
    name: '未融资'
  },
  {
    id: 2,
    name: '天使轮'
  },
  {
    id: 3,
    name: 'A轮'
  },
  {
    id: 4,
    name: 'B轮'
  },
  {
    id: 5,
    name: 'C轮'
  },
  {
    id: 6,
    name: 'D轮及以上'
  },
  {
    id: 7,
    name: '上市公司'
  },
  {
    id: 8,
    name: '不需要融资'
  },
  {
    id: 12,
    name: '其他'
  }
]
